import { createFileRoute } from '@tanstack/react-router';

import { WgScheduleView } from 'src/sections/white-glove/schedule/wg-schedule-view';

export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/schedule'
)({
  component: WgSchedulePage,
});

function WgSchedulePage() {
  return <WgScheduleView />;
}
